import { sessionFetch } from '../../../utils/sessionFetch';
import { getServerEndpoint, getSubdomain } from '../../../utils/utils';

const API_KEY = '453dabb4-7645-4626-a1bb-477dff3aa557';

export const requestPinyaCopilotSuggestion = async (payload, options = {}) => {
    const colla = getSubdomain();
    const serverEndpoint = getServerEndpoint(colla);

    const response = await sessionFetch(`${serverEndpoint}/api/pissarra/copilot/suggest`, {
        method: 'POST',
        headers: {
            'x-api-key': API_KEY,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        signal: options.signal,
    });

    if (!response.ok) {
        throw new Error(`Copilot API error ${response.status}`);
    }

    return response.json();
};

export const requestPinyaCopilotPrecompute = async (payload, options = {}) => {
    const colla = getSubdomain();
    const serverEndpoint = getServerEndpoint(colla);

    const response = await sessionFetch(`${serverEndpoint}/api/pissarra/copilot/precompute`, {
        method: 'POST',
        headers: {
            'x-api-key': API_KEY,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        signal: options.signal,
    });

    if (!response.ok) {
        throw new Error(`Copilot precompute API error ${response.status}`);
    }

    return response.json();
};
